module.exports = __webpack_public_path__ + "img/tabicon_4.676fd88e.png";